import React from 'react';
import T from 'prop-types';
import { Navigation } from '@piggybank/form';

export const ReviewDetailsParentComponent = (props) => {
  return (
    <>
      {props.children}
      <Navigation />
    </>
  );
};

ReviewDetailsParentComponent.propTypes = {
  children: T.object,
};
